import React from "react";

const WelcomeComponent = () => {
  return (
    <div className="user-index-welcome-container">
      <div className="user-index-welcome-content">
        <h1>Users Management Area</h1>
        <div className="user-index-guidance-text">
          To access user details, utilize the search input to locate users and
          select them to view additional information.
        </div>
      </div>
    </div>
  );
};

export default WelcomeComponent;
